const FullPageLoader = () => {
    return (
        <div className="flex fixed inset-0 justify-center items-center z-[9999] bg-white/50">
            <div className="w-8 h-8 rounded-full border-4 border-black animate-spin border-t-transparent"></div>
        </div>
    );
};

export default FullPageLoader;
